/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  track web vitals metrics (LCP, CLS, FCP, FID, TTFB)
 */

import { getUser, selectIsBot, selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import { type TrackEventPayload, event } from '@zcode-ui/web-zumper-integrations'
import { trackWebVitals } from '@zcode/ga-utils'
import type { Dispatch, GetState } from '@zcode/state-type'

import { isCypress } from '@zcode/utils'
import { getCurrentLocation } from '../../../inspectors/index'
import { NOMAD_ALLOC_ID } from '../../../settings/settings'

const eventWithCustomAttributes = (payload: TrackEventPayload) => {
  if (isCypress()) {
    console.log('Web Vitals Metric Event', payload)
  }
  return event({
    ...payload,
    props: {
      ...payload.props,
      allocId: NOMAD_ALLOC_ID,
      gitSha: window.__GIT_SHA__,
    },
  })
}

export const trackWebVitalsMetricsEvent =
  (getPageType: () => string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const user = getUser(state)
    const mobile = selectIsMobile(state)
    const location = getCurrentLocation(state)
    const bot = selectIsBot(state)
    const { url: cityState } = location || {}

    dispatch(
      trackWebVitals({
        bot,
        cityState: cityState ?? undefined,
        event: eventWithCustomAttributes,
        getPageType,
        location,
        mobile,
        user,
      })
    )
  }
